<template>
    <div class="sincomisiones-section">
        <div class="sincomisiones-content">
            <h2 class="sincomisiones-title fuente-posm">
                Deja de Pagar Comisiones por Cada Venta
            </h2>
            <p class="sincomisiones-text fuente-nova">
                Con tu propio sitio y app, el cliente paga directamente en tu pasarela de pagos. Cero comisiones de plataformas. Todo el ticket es para ti.
            </p>
        </div>
        <div class="sincomisiones-image">
            <img :src="a69" alt="Sin comisiones">
        </div>
    </div>
</template>

<script>
export default {
    name: 'SinComisionesNew',
    data() {
        return {
            a69: require('@/assets/images/a69.webp')
        }
    }
}
</script>

<style lang="css" scoped>
.sincomisiones-section {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 40px 60px;
    box-sizing: border-box;
    scroll-snap-align: start;
    gap: 40px;
}

.sincomisiones-image {
    flex: 0 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    order: 1;
}

.sincomisiones-image img {
    width: 280px;
    height: auto;
}

.sincomisiones-content {
    flex: 1;
    max-width: 700px;
    order: 2;
}

.sincomisiones-title {
    color: var(--color-2);
    font-size: 68px;
    line-height: 1.1;
    margin: 0 0 20px 0;
}

.sincomisiones-text {
    color: var(--color-3);
    font-size: 29px;
    line-height: 1.3;
    margin: 0;
    padding-left: 10px;
}

/* Tablet */
@media (max-width: 992px) and (min-width: 769px) {
    .sincomisiones-title {
        font-size: 60px;
    }

    .sincomisiones-text {
        font-size: 27px;
    }

    .sincomisiones-image img {
        width: 220px;
    }
}

/* Mobile */
@media (max-width: 768px) {
    .sincomisiones-section {
        flex-direction: column;
        justify-content: flex-start;
        height: 100vh;
        padding: 100px 20px 40px 20px;
        gap: 20px;
    }

    .sincomisiones-content {
        order: 1;
        max-width: 100%;
        flex: none;
    }

    .sincomisiones-image {
        order: 2;
        width: 100%;
        flex: 1;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        padding-top: 20px;
    }

    .sincomisiones-image img {
        width: 60%;
        max-width: 240px;
    }

    .sincomisiones-title {
        font-size: 24px;
        line-height: 1.2;
        margin: 0 0 10px 0;
    }

    .sincomisiones-text {
        font-size: 16px;
        padding-left: 10px;
        margin: 0;
    }
}
</style>
